module.exports = __webpack_public_path__ + "img/halloween-window-11.b0bf32ee.svg";